import Link from "@/components/link/Link";
import { BreadcrumbTrail } from "@/types/breadcrumbs";
import styles from "./Breadcrumb.module.scss";

type BreadcrumbProps = {
  trail: BreadcrumbTrail;
};

export const Breadcrumb = ({ trail }: BreadcrumbProps) => (
  <nav aria-label="breadcrumb" className={styles.container}>
    <ol className={styles.list}>
      {trail.map((item, index) => {
        const isLastItem = index === trail.length - 1;
        return (
          <li key={item.name} className={styles.item}>
            {item.url && !isLastItem ? (
              <Link next href={item.url}>
                {item.name}
              </Link>
            ) : (
              <span className={styles.current}>{item.name}</span>
            )}
            {!isLastItem && <span className={styles.separator}>&gt;</span>}
          </li>
        );
      })}
    </ol>
  </nav>
);
